import { ImageLegendVariant } from '../image-legend';

/**
 * Returns the aria label for the image legend based on the variant and labels
 *
 * @param variant - The variant of the image legend
 * @param leftLabel - The left label of the image legend
 * @param rightLabel - The right label of the image legend
 * @param gazeSequencePoints - The number of gaze sequence points
 * @returns The aria label for the image legend
 */
const getAriaLabel = (
  variant: ImageLegendVariant,
  leftLabel?: string,
  rightLabel?: string,
  gazeSequencePoints?: number,
) => {
  switch (variant) {
    case ImageLegendVariant.AttentionMap:
      return `Attention map visualization from ${leftLabel || 'Less attention'} to ${rightLabel || 'More attention'}`;
    case ImageLegendVariant.GazeSequence:
      return `Gaze sequence visualization with ${gazeSequencePoints} points`;
    case ImageLegendVariant.FocalPoints:
      return 'Focal points visualization from 0 to 100%';
    case ImageLegendVariant.AttentionDrivers:
      return `Attention drivers visualization from ${leftLabel || 'Low driver'} to ${rightLabel || 'High driver'}`;
    case ImageLegendVariant.AttentionDetractors:
      return `Attention detractors visualization from ${leftLabel || 'Low detractor'} to ${rightLabel || 'High detractor'}`;
    default:
      return leftLabel && rightLabel
        ? `Image legend with label ${leftLabel} and ${rightLabel}`
        : leftLabel
          ? `Image legend with label ${leftLabel}`
          : 'Image legend';
  }
};

export { getAriaLabel };
